import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SideMenu from "./../dashboard/components/SideMenu";
import Header from "./../dashboard/components/Header";
import { AppDispatch } from "../../reduxStore/store";
import { useDispatch } from "react-redux";
import TimelineComponent from "./TimelineComponent";
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';

export default function TimelineViewComponent(props: { disableCustomTheme?: boolean }) {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const { selectedRow } = location.state || {};
  const sideMenuOpenLocal = localStorage.getItem("sideMenuToggle");
  const [open, setOpen] = useState(
    sideMenuOpenLocal === null ? false : true
  );
  const [reportTypeId, setReportTypeId] = useState(1);
  // const [emrValues, setEmrValues] = useState<any>();
  // const [lisValues, setLisValues] = useState<any>();
  // const [imsValues, setIMSValues] = useState<any>();
  useEffect(() => {
    const sideMenuOpenLocal = localStorage.getItem("sideMenuToggle");
    if (sideMenuOpenLocal !== null) {
      setOpen(sideMenuOpenLocal === "true" ? true : false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleDrawer = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  const timelineItems = [
    { id: 1, content: 'EMR', start: '2025-04-20' },
    { id: 2, content: 'LIS', start: '2025-04-14' },
    { id: 3, content: 'IMS', start: '2025-04-18' },
    { id: 4, content: 'AI', start: '2025-04-16', end: '2025-04-19' },
  ];

  const handleSelect = (itemId: number) => {
    setReportTypeId(itemId);
  };
  return (
    <Stack
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "background.paper",
      }}
    >
      <Header open={open} toggleDrawer={toggleDrawer} />
      <Box sx={{ display: "flex" }}>
        <SideMenu open={open} />
        {/* Main content */}
        <Box
          component="main"
          sx={(_theme) => ({
            flexGrow: 1,
            overflow: "auto",
          })}
        >
          <Stack
            spacing={1}
            sx={{
              height: "calc(100vh - 80px)",
              mr: 2,
              ml: open ? 0 : 2,
            }}
          >
            <TimelineComponent
              items={timelineItems}
              onSelectItem={handleSelect}
              documentData={selectedRow}
              selectedFilterTypeValue={reportTypeId}
              onFilterChange={setReportTypeId} />
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
}
